import React, { Component } from 'react'
import {Carousel, Col} from 'react-bootstrap'
import Slider from 'react-slick'
import Propiedad from '../../containers/Sections/Propiedades/propiedad'
import Spinner from '../Spinner'

export default class SliderFixed extends Component {

  render () {

  	const { properties, detail } = this.props

  	if (properties.length) {
			return (
        <div className="slider-properties-container">
  				<div className="container-propiedades">
  					{properties.map((item, index) =>
  						<Col md={4} sm={6} key={index}>
  							<Propiedad property={item}/>
  						</Col>
  					)}
  				</div>
        </div>
			)
		}
  	else{
  		return (
	    	<Spinner />
	    )
  	}
  }
}



// WEBPACK FOOTER //
// ./src/components/Slider/fixed.js